import React, { useState, useEffect } from 'react';
import { Page } from 'src/containers';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Div, Row, Col } from '@pinpoint/design-kit';

import { ButtonCard } from 'src/components';
import CONSTANTS from 'src/store/constants';
import { ROUTES } from 'src/config';

function OnboardingLanding() {
  const [isPredictModelDisabled, disablePredictModel] = useState(true);
  const [isGenerateModelDisabled, disableGenerateModel] = useState(true);
  const history = useHistory();
  const client = useSelector(({ app: { client: _client } }) => _client);

  useEffect(() => {
    if (client) {
      disablePredictModel(!client.canScore);
      disableGenerateModel(!client.canModel);
    } else {
      disablePredictModel(true);
      disableGenerateModel(true);
    }
  }, [client]);

  return (
    <Div d="flex" p={{ t: '4.5rem', l: '8.875rem' }} flexDir="column">
      <Row m="0" p={{ t: '3.875rem' }}>
        <Col gutterWidth="0">
          <ButtonCard
            m="0"
            iconName="AI"
            iconViewBox="0 0 51 60"
            name="Generate Models"
            description="Build predictive models based on historical data"
            hoverTopBg="navyBlue"
            bottomBg="navyBlue"
            hoverBottomBg="navyBlueDark"
            disabled={isGenerateModelDisabled}
            onClick={() => {
              history.push(ROUTES.GENERATE_MODELS);
            }}
            cardProps={{ 'data-debug': 'onboarding-generate-models-card' }}
          />
        </Col>
        <Col gutterWidth="0">
          <ButtonCard
            m={{ y: '0', x: '2.5rem' }}
            iconName="ThinkalikeModel"
            iconViewBox="0 0 45 60"
            name="Predict Forward"
            description="Score datasets against existing models"
            hoverTopBg="navyBlue"
            bottomBg="navyBlue"
            hoverBottomBg="navyBlueDark"
            disabled={isPredictModelDisabled}
            onClick={() => {
              history.push(ROUTES.NEW_ONBOARDING, {
                model: CONSTANTS.ONBOARDING_MODELS.PREDICT_MODEL,
                datasetTag: CONSTANTS.SEGMENT.TAG.TARGET,
              });
            }}
            cardProps={{ 'data-debug': 'onboarding-predict-forward-card' }}
          />
        </Col>
        <Col gutterWidth="0">
          <ButtonCard
            m="0"
            iconName="OnboardingLog"
            iconViewBox="0 0 45 60"
            name="Onboarding Log"
            description="View log of onboarded datasets"
            hoverTopBg="navyBlue"
            bottomBg="navyBlue"
            hoverBottomBg="navyBlueDark"
            onClick={() => {
              history.push(ROUTES.ONBOARDING);
            }}
            cardProps={{ 'data-debug': 'onboarding-log-card' }}
          />
        </Col>
      </Row>
    </Div>
  );
}

export default Page(OnboardingLanding);
